import { Component, memo } from 'react';
import { combineUrl } from '@agilepoint/utils-common';
import { IAppContext, IConfigurationBase } from '@agilepoint/wat';
import { FlexBox, IIconSprite, WatReactAppContainer, WithNotificationList } from '@agilepoint/wat-react-ux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { IApplicationConfig } from 'types';
import Login from '../component/login';
import { SessionOutPage } from '../component/session-out-page';
import styled from 'styled-components';
import { CopyRightInfo } from 'common/copyright-info';
interface ILoginPageProps<TConfig extends IConfigurationBase> {
    appContext: IAppContext<TConfig>;
}

interface IAppRouterProps {
    appContext: IAppContext<IApplicationConfig>;
    children: any;
}

const CoreAppLayout = styled.div`
    letter-spacing: .1px;
    background: linear-gradient(180deg,#ffff 42%, #f8f9fa 42%);
    height: 100%;
    width: 100%;
    border: white;
`;

const BottomRightNotificationList = styled(WithNotificationList)`
    bottom: 50px;
    right: 32px;
    top: unset;
    left: unset;
    width: auto;
`;

const StyledFlexBox = styled(FlexBox)`
    background-color: #f8f9fa;
`;

function getIconsPath(basePath: string) {
    const genericIconsSpritePath = combineUrl(basePath, '/assets/icons/generic/sprite.symbol.svg');
    const mobileAppAcceleratorIconsSpritePath = combineUrl(basePath, '/assets/icons/mobile-app-accelerator/sprite.symbol.svg');
    const iconSpriteAddons: IIconSprite[] = [
        { name: 'workcenter', src: mobileAppAcceleratorIconsSpritePath }
    ];
    return { genericIconsSpritePath, iconSpriteAddons };
}

const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false } } });

const AppRouter = memo(({ appContext, children }: IAppRouterProps) => (
    <BrowserRouter basename={appContext.configuration.baseUrl}>
        {children}
    </BrowserRouter>
));

function OpenLoginPage() {
    return <Navigate to="/login" />;
}

export class LoginPage<TConfig extends IApplicationConfig> extends Component<ILoginPageProps<TConfig>> {
    render() {
        const { appContext } = this.props;
        const { genericIconsSpritePath, iconSpriteAddons } = getIconsPath(appContext.configuration.basePath);
        return (
            <WatReactAppContainer themeName="mobile-app-accelerator-default" iconSpriteAddons={iconSpriteAddons} genericIconSpritePath={genericIconsSpritePath} >
                <QueryClientProvider client={queryClient}>
                    <BottomRightNotificationList>
                        <CoreAppLayout>
                            <AppRouter appContext={appContext}>
                                <Routes>
                                    <Route key="home-route" path="/" element={OpenLoginPage()} />
                                    <Route key="login-route" path="/login" element={<Login />} />
                                    {/* <Route key="reset-password" path="/reset-password" element={<ResetPassword />} /> */}
                                    <Route path='*' element={<SessionOutPage />} />
                                </Routes>
                            </AppRouter>
                            <StyledFlexBox justifyContent="center" alignItems="center" height='30px'>
                                <CopyRightInfo>© Copyright 2024 AgilePoint.All Rights Reserved.</CopyRightInfo>
                            </StyledFlexBox>
                        </CoreAppLayout>
                    </BottomRightNotificationList>
                </QueryClientProvider>
            </WatReactAppContainer>);
    }
}
